var map = {
	"./background.jpg": 1659,
	"./pic1.jpg": 3138,
	"./pic10.jpg": 4863,
	"./pic11.jpg": 9346,
	"./pic12.jpg": 9863,
	"./pic13.jpg": 3196,
	"./pic14.jpg": 612,
	"./pic15.jpg": 7610,
	"./pic16.jpg": 2134,
	"./pic17.jpg": 1522,
	"./pic18.jpg": 7496,
	"./pic19.jpg": 4540,
	"./pic2.jpg": 459,
	"./pic20.jpg": 2454,
	"./pic3.jpg": 7322,
	"./pic4.jpg": 9685,
	"./pic5.jpg": 8017,
	"./pic6.jpg": 5426,
	"./pic7.jpg": 7458,
	"./pic8.jpg": 1773,
	"./pic9.jpg": 4754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;